
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","stroke":"currentColor","stroke-width":"1.212"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.553 10.114a2.667 2.667 0 11-3.772 3.772 2.667 2.667 0 013.772-3.772m10.666-5.333a2.667 2.667 0 11-3.772 3.772 2.667 2.667 0 013.772-3.772zm0 10.666a2.667 2.667 0 11-3.772 3.772 2.667 2.667 0 013.772-3.772M9.04 10.81l5.92-2.96m-5.92 5.34l5.92 2.96"}})])
          )
        }
      }
    